import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const InitiateMovement = React.lazy(() =>
  import("@/pages/movement/reportingManager/initiateMovement.jsx")
);

const ReportingManagerTab = React.lazy(() =>
  import("@/pages/movement/reportingManager/reportingManagerTab.jsx")
);
const ReviewerTab = React.lazy(() =>
  import("@/pages/movement/reviewer/reviewerTab.jsx")
);
const Index = React.lazy(() => import("@/pages/movement/index.jsx"));
const Movement = [
  {
    path: "movement",
    element: (
      <SuspenseWrapper>
        <Index />
      </SuspenseWrapper>
    ),
  },


  
  {
    path: "reportingManagerMovements",
    element: (
      <SuspenseWrapper>
        <ReportingManagerTab />
      </SuspenseWrapper>
    ),
  },
  {
    path: "movementInitiate",
    element: (
      <SuspenseWrapper>
        <InitiateMovement />
      </SuspenseWrapper>
    ),
  },
  {
    path: "myteams",
    element: (
      <SuspenseWrapper>
        <ReviewerTab />
      </SuspenseWrapper>
    ),
  },
];
export default Movement;
